import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import i18n from '../../i18n';

export default class SideBar extends Component {
    render() {
        return (
            <I18n>{(t, { i18n }) => (
            <div className="sidebar-container">
                <div className="sidebar-wrapper" id="sidebar-wrapper">
                    <div className="sidebar-content__text">
                        <h4>{t('assortmentSideBarTitle')}</h4>
                        <span className="mt5">{t('assortmentSideBarExporter')}</span>
                        <a
                            className="btn"
                            href="https://www.floraxchange.nl/Account/Kweker/533/Forever-Plants-Group"
                            target="_blank"
                            rel="noopener noreferrer">
                            FloraXchange
                        </a>
                        <span className="mt10">{t('assortmentSideBarConsumer')}</span>
                        <a
                            className="btn btn-modifier"
                            href="https://www.plantsome.nl/"
                            target="_blank"
                            rel="noopener noreferrer">
                            Plantsome
                        </a>
                    </div>
                </div>
            </div>
            )}</I18n>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx